<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มกลุ่มสิทธิใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ rightGroupInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ rightGroupInit.title_en }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <div>
          <label class="body-2">
            รหัสกลุ่มสิทธิ์
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            v-model="rightGroup.authority_code"
            :rules="[
              (v) => !!v || 'โปรดระบุรหัสกลุ่มสิทธิ์',
              (v) =>
                !v ||
                (v && v.length <= 10) ||
                'รหัสกลุ่มสิทธิ์ ต้องน้อยกว่า 10 ตัวอักษร',
            ]"
            outlined
            dense
            required
            clearable
            @change="checkEmpty($event, 'authority_code')"
          >
          </v-text-field>
        </div>
        <div>
          <label class="body-2">
            คำอธิบาย (ไทย)
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            v-model="rightGroup.title_th"
            :rules="[(v) => !!v || 'โปรดระบุคำอธิบาย']"
            outlined
            dense
            required
            clearable
            @change="checkEmpty($event, 'title_th')"
          >
          </v-text-field>
        </div>
        <div>
          <label class="body-2"> คำอธิบาย (อังกฤษ) </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            v-model="rightGroup.title_en"
            outlined
            dense
            clearable
            @change="checkEmpty($event, 'title_en')"
          >
          </v-text-field>
        </div>
        <div>
          <label class="body-2">
            ช่วงเวลา
            <span class="red--text"><strong>*</strong></span>
            <button
              type="button"
              class="ml-5 btn-text"
              @click.stop="handleClickView()"
            >
              ดูแผนภาพ
            </button>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            v-model="rightGroup.timezone_uuid"
            :rules="[(v) => !!v || 'โปรดระบุช่วงเวลา']"
            :items="
              timezones.map((timezone) => ({
                ...timezone,
                text: `${timezone.timezone_code} - ${timezone.title_th}`,
              }))
            "
            item-text="text"
            item-value="timezone_uuid"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
        <div>
          <label class="body-2">
            กลุ่ม Device
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            v-model="rightGroup.hardware_group_uuid"
            :rules="[(v) => !!v || 'โปรดระบุกลุ่ม Device']"
            :items="hardwaresGroup"
            item-text="title_th"
            item-value="hardware_group_uuid"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
        <div>
          <label class="body-2">
            กลุ่มพนักงาน
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            v-model="rightGroup.employee_group_uuid"
            :rules="[(v) => !!v || 'โปรดระบุกลุ่ม พนักงาน']"
            :items="employeesGroup"
            item-text="title_th"
            item-value="employee_group_uuid"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
        <div v-if="isTimeAttendanceOnly">
          <v-dialog
            ref="dialogDateStartAccess"
            v-model="modalDateStartAccess"
            :return-value.sync="rightGroup.access_control_date_start"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <div>
                <label class="body-2"> วันเริ่มใช้งาน </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  :value="rightGroupAccessDateStartFormatted"
                  :rules="[ruleAccessDateStart || 'จำเป็นต้องใส่วันที่']"
                  append-icon="mdi-calendar"
                  @click:append="modalDateStartAccess = true"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="rightGroupClear('access_control_date_start')"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </template>
            <v-date-picker
              v-model="rightGroup.access_control_date_start"
              scrollable
              locale="th-TH"
              :year-format="yearFormatted"
              :header-date-format="headerDateFormatted"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modalDateStartAccess = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="
                  $refs.dialogDateStartAccess.save(
                    rightGroup.access_control_date_start
                  )
                "
                >ตกลง
              </v-btn>
            </v-date-picker>
          </v-dialog>

          <v-dialog
            ref="dialogTimeStartAccess"
            v-model="modalTimeStartAccess"
            :return-value.sync="rightGroup.access_control_time_start"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <div>
                <label class="body-2"> เวลาเริ่มใช้งาน </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  :value="rightGroup.access_control_time_start"
                  :rules="[ruleAccessTimeStart || 'จำเป็นต้องใส่เวลา']"
                  append-icon="mdi-clock-outline"
                  @click:append="modalTimeStartAccess = true"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="rightGroupClear('access_control_time_start')"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </template>
            <v-time-picker
              v-if="modalTimeStartAccess"
              v-model="rightGroup.access_control_time_start"
              full-width
              format="24hr"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modalTimeStartAccess = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="
                  $refs.dialogTimeStartAccess.save(
                    rightGroup.access_control_time_start
                  )
                "
                >ตกลง
              </v-btn>
            </v-time-picker>
          </v-dialog>

          <v-dialog
            ref="dialogDateExpireAccess"
            v-model="modalDateExpireAccess"
            :return-value.sync="rightGroup.access_control_date_expire"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <div>
                <label class="body-2"> วันสิ้นสุดใช้งาน </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  :value="rightGroupAccessDateExpireFormatted"
                  :rules="[ruleAccessDateExpire || 'จำเป็นต้องใส่วันที่']"
                  append-icon="mdi-calendar"
                  @click:append="modalDateExpireAccess = true"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="rightGroupClear('access_control_date_expire')"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </template>
            <v-date-picker
              v-model="rightGroup.access_control_date_expire"
              scrollable
              locale="th-TH"
              :year-format="yearFormatted"
              :header-date-format="headerDateFormatted"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modalDateExpireAccess = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="
                  $refs.dialogDateExpireAccess.save(
                    rightGroup.access_control_date_expire
                  )
                "
                >ตกลง
              </v-btn>
            </v-date-picker>
          </v-dialog>

          <v-dialog
            ref="dialogTimeExpireAccess"
            v-model="modalTimeExpireAccess"
            :return-value.sync="rightGroup.access_control_time_expire"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <div>
                <label class="body-2"> เวลาสิ้นสุดใช้งาน </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  :value="rightGroup.access_control_time_expire"
                  :rules="[ruleAccessTimeExpire || 'จำเป็นต้องใส่เวลา']"
                  append-icon="mdi-clock-outline"
                  @click:append="modalTimeExpireAccess = true"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="rightGroupClear('access_control_time_expire')"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </template>
            <v-time-picker
              v-if="modalTimeExpireAccess"
              v-model="rightGroup.access_control_time_expire"
              full-width
              format="24hr"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modalTimeExpireAccess = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="
                  $refs.dialogTimeExpireAccess.save(
                    rightGroup.access_control_time_expire
                  )
                "
                >ตกลง
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isRightGroupDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::authority:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::authority:create')"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::authority:update')"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <v-dialog v-model="dialogView" width="1280">
      <v-card>
        <v-card-title class="body-2 grey lighten-2 d-flex">
          <div class="flex-grow-1 d-flex">
            <div style="width: 280px">
              <div style="color: gray">รหัสช่วงเวลา :</div>
              <div class="body-2">{{ timezone.timezone_code }}</div>
            </div>
            <div>
              <div style="color: gray">คำอธิบาย (ไทย)</div>
              <div class="body-2">{{ timezone.title_th }}</div>
            </div>
          </div>
          <div>
            <v-btn icon @click="dialogView = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="py-6">
          <TimezoneTable :timezoneDetail="timezone.timezone_detail" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TimezoneTable from '@/components/TimezoneTable.vue'

export default {
  components: {
    ConfirmDialog,
    TimezoneTable,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    rightGroup: {
      type: Object,
    },
    rightGroupInit: {
      type: Object,
    },
  },
  data() {
    return {
      modalDateStartAccess: false,
      modalDateExpireAccess: false,
      modalTimeStartAccess: false,
      modalTimeExpireAccess: false,
      timezone: {
        timezone_code: '',
        title_th: '',
        timezone_detail: [],
      },
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      dialogView: false,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isTimeAttendanceOnly() {
      const timezone = this.timezones.find(
        (timezone) => timezone.timezone_uuid === this.rightGroup.timezone_uuid
      )
      if (timezone?.timezone_code === 'TA') {
        return false
      } else {
        return true
      }
    },
    ruleAccessDateStart() {
      if (
        this.rightGroup.access_control_time_start &&
        !this.rightGroup.access_control_date_start
      )
        return false
      return true
    },
    ruleAccessTimeStart() {
      if (
        this.rightGroup.access_control_date_start &&
        !this.rightGroup.access_control_time_start
      )
        return false
      return true
    },
    ruleAccessDateExpire() {
      if (
        this.rightGroup.access_control_time_expire &&
        !this.rightGroup.access_control_date_expire
      )
        return false
      return true
    },
    ruleAccessTimeExpire() {
      if (
        this.rightGroup.access_control_date_expire &&
        !this.rightGroup.access_control_time_expire
      )
        return false
      return true
    },
    rightGroupAccessDateStartFormatted() {
      return this.rightGroup.access_control_date_start
        ? moment(this.rightGroup.access_control_date_start).format('DD/MM/YYYY')
        : ''
    },
    rightGroupAccessDateExpireFormatted() {
      return this.rightGroup.access_control_date_expire
        ? moment(this.rightGroup.access_control_date_expire).format(
            'DD/MM/YYYY'
          )
        : ''
    },
    isRightGroupDataChange() {
      if (
        this.rightGroup?.hardware_group_uuid !==
          this.rightGroupInit?.hardware_group_uuid ||
        this.rightGroup?.employee_group_uuid !==
          this.rightGroupInit?.employee_group_uuid ||
        this.rightGroup?.timezone_uuid !== this.rightGroupInit?.timezone_uuid ||
        this.rightGroup.authority_code !== this.rightGroupInit.authority_code ||
        this.rightGroup.title_th !== this.rightGroupInit.title_th ||
        this.rightGroup.title_en !== this.rightGroupInit.title_en ||
        this.rightGroup.access_control_date_start !==
          this.rightGroupInit.access_control_date_start ||
        this.rightGroup.access_control_date_expire !==
          this.rightGroupInit.access_control_date_expire ||
        this.rightGroup.access_control_time_start !==
          this.rightGroupInit.access_control_time_start ||
        this.rightGroup.access_control_time_expire !==
          this.rightGroupInit.access_control_time_expire
      ) {
        this.$emit('isRightGroupDataChange', true)
        return true
      }
      this.$emit('isRightGroupDataChange', false)
      return false
    },
    hardwaresGroup() {
      return this.$store.state.hardwaresGroup.hardwaresGroup
    },
    employeesGroup() {
      return this.$store.state.employeesGroup.employeesGroup
    },
    timezones() {
      return this.$store.state.timezone.timezones
    },
  },
  methods: {
    ...mapActions({
      addRightGroup: 'rightsGroup/addRightGroup',
      editRightGroup: 'rightsGroup/editRightGroup',
      deleteRightGroup: 'rightsGroup/deleteRightGroup',
    }),
    handleClickView() {
      this.dialogView = true
      const timezoneSelected = this.timezones.find(
        (timezone) => timezone.timezone_uuid === this.rightGroup.timezone_uuid
      )
      this.timezone = {
        timezone_code: timezoneSelected.timezone_code,
        title_th: timezoneSelected.title_th,
        timezone_detail: timezoneSelected.timezone_detail.map((timezone) => {
          return {
            timezone_detail_uuid: timezone.timezone_detail_uuid,
            timezone_time_period: timezone.timezone_time_period.map((item) => {
              if (item.time_period_start && item.time_period_end) {
                return {
                  time_period_start: item.time_period_start,
                  time_period_end: item.time_period_end,
                  start:
                    Number(item.time_period_start.split(':')[0]) * 44 +
                    (Number(item.time_period_start.split(':')[1]) / 60) * 44,
                  end:
                    (Number(item.time_period_end.split(':')[0]) -
                      Number(item.time_period_start.split(':')[0])) *
                      44 +
                    Number(item.time_period_end.split(':')[1] / 60) * 44 -
                    Number(item.time_period_start.split(':')[1] / 60) * 44,
                }
              }
            }),
          }
        }),
      }
    },
    yearFormatted(year) {
      return `ค.ศ. ${year}`
    },
    headerDateFormatted(date) {
      // use momentjs
      return moment(date).locale('th').format('MMMM YYYY')

      // not use library
      // const monthsOfYear = [
      //   'มกราคม',
      //   'กุมภาพันธ์',
      //   'มีนาคม',
      //   'เมษายน',
      //   'พฤษภาคม',
      //   'มิถุนายน',
      //   'กรกฎาคม',
      //   'สิงหาคม',
      //   'กันยายน',
      //   'ตุลาคม',
      //   'พฤศจิกายน',
      //   'ธันวาคม'
      // ]
      // let i = new Date(date).getMonth(date)
      // return `${monthsOfYear[i]} ${date.split('-')[0]}`
    },
    rightGroupClear(field) {
      this.rightGroup[field] = undefined
    },
    checkEmpty(value, field) {
      if (value) {
        this.rightGroup[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบกลุ่มสิทธิ์',
        value: this.rightGroup.title_th,
        item: this.rightGroup,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete({ authority_uuid }) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        authority_uuid,
      }

      this.deleteRightGroup(payload)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          body: {
            hardware_group_uuid: this.rightGroup.hardware_group_uuid,
            employee_group_uuid: this.rightGroup.employee_group_uuid,
            timezone_uuid: this.rightGroup.timezone_uuid,
            authority_code: this.rightGroup.authority_code,
            title_th: this.rightGroup.title_th,
            title_en: this.rightGroup.title_en || null,
            access_control_start_time:
              this.rightGroup.access_control_date_start &&
              this.rightGroup.access_control_time_start
                ? moment
                    .utc(
                      `${this.rightGroup.access_control_date_start} ${this.rightGroup.access_control_time_start}`
                    )
                    .format()
                : null,
            access_control_end_time:
              this.rightGroup.access_control_date_expire &&
              this.rightGroup.access_control_time_expire
                ? moment
                    .utc(
                      `${this.rightGroup.access_control_date_expire} ${this.rightGroup.access_control_time_expire}`
                    )
                    .format()
                : null,
          },
        }

        this.addRightGroup(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          authority_uuid: this.rightGroup.authority_uuid,
          body: {
            hardware_group_uuid: this.rightGroup.hardware_group_uuid,
            employee_group_uuid: this.rightGroup.employee_group_uuid,
            timezone_uuid: this.rightGroup.timezone_uuid,
            authority_code: this.rightGroup.authority_code,
            title_th: this.rightGroup.title_th,
            title_en: this.rightGroup.title_en || null,
            access_control_start_time: !this.isTimeAttendanceOnly
              ? null
              : this.rightGroup.access_control_date_start &&
                this.rightGroup.access_control_time_start
              ? moment
                  .utc(
                    `${this.rightGroup.access_control_date_start} ${this.rightGroup.access_control_time_start}`
                  )
                  .format()
              : null,
            access_control_end_time: !this.isTimeAttendanceOnly
              ? null
              : this.rightGroup.access_control_date_expire &&
                this.rightGroup.access_control_time_expire
              ? moment
                  .utc(
                    `${this.rightGroup.access_control_date_expire} ${this.rightGroup.access_control_time_expire}`
                  )
                  .format()
              : null,
          },
        }

        this.editRightGroup(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isRightGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
